import { ImageIcon, Trash2 } from "lucide-react";

import { uploadImage } from "@/api/form";

import { Input } from "@/components/ui/input";

import ToolbarButton from "./toolbar-button";

const IMAGE_ROOT = import.meta.env.VITE_FORM_API_URL;

const BackgroundImagePicker: React.FC<
  React.ComponentProps<"button"> & {
    editorRef: React.RefObject<HTMLDivElement>;
  }
> = ({ editorRef }) => {
  const removeBackgroundImage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    if (!editorRef.current) return;

    editorRef.current.style.backgroundImage = "";
    editorRef.current.style.backgroundSize = "";
    editorRef.current.style.backgroundPosition = "";
    editorRef.current.style.backgroundRepeat = "";
  };

  const hasBackground = !!editorRef.current?.style.backgroundImage;

  return (
    <ToolbarButton className="relative w-fit px-3">
      <label className="flex cursor-pointer items-center gap-x-2">
        <ImageIcon className="size-4" />

        <span>Background image</span>

        <Input
          type="file"
          accept="image/*"
          onChange={async (e) => {
            const file = e.target.files?.[0];
            if (!file) return;

            const formData = new FormData();
            formData.append("image", file);

            const response = await uploadImage(formData);

            if (response?.imageUrl && editorRef.current) {
              const imageUrl = response.imageUrl.replace(/\\/g, "/");

              editorRef.current.style.backgroundImage = `url(${IMAGE_ROOT}/${imageUrl})`;

              editorRef.current.style.backgroundSize = "cover";
              editorRef.current.style.backgroundPosition = "center";
              editorRef.current.style.backgroundRepeat = "no-repeat";
            }

            e.target.value = "";
          }}
          className="absolute inset-0 cursor-pointer opacity-0"
        />

        {hasBackground && (
          <button
            type="button"
            onClick={removeBackgroundImage}
            className="hover:bg-muted z-10 rounded p-1"
          >
            <Trash2 className="size-4 text-red-500" />
          </button>
        )}
      </label>
    </ToolbarButton>
  );
};

export default BackgroundImagePicker;
